import { useMemo } from 'react'
import { resolveRange, type DateRange, type Flight } from '@/services/stats/statsRange'
import { useNetwork } from '../contexts/NetworkContext'

/**
 * The concrete period a picked range means for this object — the picker and the
 * queries want different things from the same choice. The picker keeps the
 * choice ("the flight"), the queries need the dates it works out to, read in
 * the network's own time zone.
 */
export function useResolvedRange(range: DateRange, flight?: Flight): DateRange {
  const { currentNetwork } = useNetwork()
  const timeZone = currentNetwork?.timeZone ?? 'UTC'
  return useMemo(
    () => resolveRange(range, flight, timeZone),
    [range, flight?.startDate, flight?.endDate, timeZone]
  )
}
